export const getIndexName = (locale: string) => {
  if (locale === 'fi') {
    return 'fi_hae';
  } else if (locale === 'sv') {
    return 'sv_sok';
  } else {
    return 'en_search';
  }
};

export const getQueryIndexName = (locale: string) => {
  if (locale === 'fi') {
    return 'fi_hae_query_suggestions';
  } else if (locale === 'sv') {
    return 'sv_sok_query_suggestions';
  } else {
    return 'en_search_query_suggestions';
  }
};
